/* [EZ] Newsletter — consent gate. The Subscribe button stays disabled until the
   privacy-consent checkbox is ticked. The button also ships disabled in markup so
   the gate holds before JS runs; this keeps it in sync as the checkbox toggles. */
(function () {
  'use strict';

  class EZNewsletter extends HTMLElement {
    connectedCallback() {
      this.consent = this.querySelector('[data-ez-nl-consent]');
      this.submit = this.querySelector('[data-ez-nl-submit]');
      if (!this.consent || !this.submit) return;
      this.sync = this.sync.bind(this);
      this.consent.addEventListener('change', this.sync);
      this.sync();
    }

    sync() {
      this.submit.disabled = !this.consent.checked;
    }
  }

  if (!customElements.get('ez-newsletter')) {
    customElements.define('ez-newsletter', EZNewsletter);
  }
})();
